module.exports = __webpack_public_path__ + "img/nonviolentcommunication.bccb9474.png";